// extracted by mini-css-extract-plugin
module.exports = {"changelogContainer":"changelog_changelogContainer__OJ8pL","header":"changelog_header__yg1vo"};